import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";
import classnames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
// hooks
import { useFetchOffers } from '../hooks/useFetchOffers'
// @components
import WebappRender from 'components/conditionalRender/webappRender'
import { CallMeBack } from 'components/callMeBack/callMeBack'
import { Examples } from '../UI/examples/examples';
import { LandingError } from '../UI/landingError/landingError'
import { OfferCard } from '../UI/offerCard/offerCard'
// @ commons
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage'
import { OKCover } from 'commonsComponents/OKCover'
import { LoadingSection } from 'commonsComponents/loadingSection'
import RiskProduct from 'components/riskProduct/riskProduct'
import { i18n } from 'core/i18n'
// @actions
import actions from 'actions/offersActions'
// @contants
import contractsActions from 'actions/contracts';
import { PROLONG_DEPOSITS_OFFERS_BUTTON_ACTION_EVENT, PROLONG_DEPOSITS_OFFERS_TAG_EVENT } from 'constants/tagging';
import { RENEWAL_DEPOSIT_HIRING_FLOW, RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION } from '../../deposits/constants/depositsConstants';
// @helpers
import { getIsFullProfitability } from 'utilities/depositHelper'
import { recordLink } from 'utilities/tagging';
import { getWidthViewport } from '../helpers/getWidthViewport'
import { offersAdapter } from '../adapters/offersAdapter'

import './landingOffersView.scss'

const DEFAULT_OFFERS_BY_COLUMNS = 3
const OFFER_IS_MID_WHEN = 2

export const LandingOffersView = ({
    history,
    immDeposits,
    immFlagBasedFeatures,
    immOffers,
    immProfile,
    originCountry,
    requestOffers,
    resetOffers,
    setRenewalOrTransferToken,
    setRenewalDepositId,
    setMaxImportAmount,
}) => {
    const { FormattedText, formatText, getFinalTitle } = i18n
    const clientName = immProfile.get('nombreCliente', '').trim()

    const depositId = history.location.query && history.location.query.depositId
    const flowId = history.location.query && history.location.query.flowId
    const isFullInterestRate = getIsFullProfitability(originCountry)
    const [offersByColumns, setOffersByColumns] = useState(DEFAULT_OFFERS_BY_COLUMNS)

    const { parsedOffers: { isDepositExpired, offers = [] } = {}, refetchOffers, error, loading } = useFetchOffers({
        adapter: offersAdapter,
        requestOffers,
        immOffers,
        immDeposits,
        depositId,
        originCountry,
        flow: flowId,
    })

    const handleResize = () => {
        const widthViewport = getWidthViewport()
        const offersByColumns = widthViewport >= 1200 ? 3 : 2

        setOffersByColumns(offersByColumns)
    }

    useEffect(() => {
        if (!depositId) history.push('/myprofile/deposits')
    }, [])

    useEffect(() => {
        window.addEventListener('resize', handleResize)
        return () => {
            resetOffers()
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const handleRedirect = ({ flowId, productId, standard, type, subtype, maxAmount }) => {
        let path = ''

        if (flowId === RENEWAL_DEPOSIT_HIRING_FLOW) {
            path = '/myprofile/purchase/depositrenewal'
            setRenewalDepositId(depositId)
        }

        if (flowId === RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION) {
            path = '/myprofile/purchase/depositexpired'
            setRenewalDepositId(depositId)
            setMaxImportAmount(maxAmount)

            const taggingProductName = `${type}.${subtype}.${standard}`
            recordLink(PROLONG_DEPOSITS_OFFERS_BUTTON_ACTION_EVENT, PROLONG_DEPOSITS_OFFERS_TAG_EVENT, taggingProductName);
        }

        setRenewalOrTransferToken(productId)
        history.push(path)
    }

    const renderOffers = () => {
        const offersLength = offers.length
    
        return offers.map(({ offerValues, supIndex, productType, ...offer }, index) => {
            const isFullWidth = ((offersLength - 1) === index && index % offersByColumns === 0) || offersLength === 1
        
            return (
                <OfferCard 
                    key={index}
                    {...offerValues}
                    supIndex={supIndex}
                    productType={productType}
                    originCountry={originCountry}
                    isFullInterestRate={isFullInterestRate}
                    isFullWidth={isFullWidth}
                    onAction={() => handleRedirect(offer)}
                />
            )
        })
    }

    const mappingBreadcrumb = [
        {
            text: formatText('deposits-title'),
            url: '/myprofile/deposits'
        },
        {
            text: formatText('offers-title'),
            url: ''
        }
    ];

    const depositOfferList = classnames('landing-offers-view__list', {
        'landing-offers-view__list--mid': offers.length === OFFER_IS_MID_WHEN,
        'landing-offers-view__list--full': offers.length > OFFER_IS_MID_WHEN,
        'landing-offers-view__list--cc': __CONTACT_CENTER__,
    });

    const columnSize = classnames('col-xs-12', {
        'col-md-9': !__CONTACT_CENTER__,
        'no-padding-left': !__CONTACT_CENTER__
    });

    const gridView = classnames('grid-view__body', {
        'grid-view__body--cc': __CONTACT_CENTER__
    })

    const titleOffers = isDepositExpired
        ? 'contractsView-contractView_landingOffersExpiredTitle'
        : 'contractsView-contractView_landingOffersTitle'

    return (
        <div className="landing-offers-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover section="accounts" customClass="col-xs-12">
                        <OKHeaderSubPage
                            titleWrap={true}
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('offers-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className={gridView}>
                <WebappRender>
                    <div className="row landing-offers-view__risk-level">
                        <RiskProduct
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            isAlertLiquidity={true}
                        />
                    </div>
                </WebappRender>
                <div>
                    <div className="row">
                        <div className={columnSize}>
                            <div className="landing-offers-view__title">
                                {
                                    !loading && <FormattedText value={titleOffers} injectedStrings={[clientName]} />
                                }
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-12"></div>
                    </div>

                    <div className="row">
                        <div className={columnSize}>
                            {
                                loading 
                                    ? <LoadingSection />
                                    : error
                                        ? <LandingError onRefetch={refetchOffers} />
                                        : (
                                            <React.Fragment>
                                                <div className={depositOfferList}>
                                                    {renderOffers()}
                                                </div>

                                                <Examples offers={offers} isFullInterestRate={isFullInterestRate} />
                                            </React.Fragment>
                                        )
                            }
                        </div>
                        <WebappRender>
                            <div className="col-xs-12 col-md-3">
                                <div className="row">
                                    <div className="col-xs-12 col-md-12">
                                        <CallMeBack
                                            isSmall={true}
                                            hasEntrance={false}
                                            pageTitle={formatText('breadcrumb-deposits')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </WebappRender>
                    </div>
                </div>
            </div>
        </div>
    )
}

LandingOffersView.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immOffers: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    requestOffers: PropTypes.func.isRequired,
    setRenewalOrTransferToken: PropTypes.func.isRequired,
};

module.exports.LandingOffersView = connect(
    state => ({
        immDeposits: state.deposits,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immOffers: state.offers,
        immProfile: state.profile,
        originCountry: state.profile.get('originCountry'),
    }), {
        requestOffers: actions.fetchOffersSelected,
        resetOffers: actions.reset,
        setRenewalDepositId: contractsActions.setRenewalDepositId,
        setRenewalOrTransferToken: contractsActions.setRenewalOrTransferToken,
        setMaxImportAmount: contractsActions.setMaxImportAmount,
    },
)(withRouter(LandingOffersView));
